import { createContext, type ReactNode, type RefObject, useContext } from 'react'

const AppShellElementContext = createContext<RefObject<HTMLDivElement | null> | null>(null)

type AppShellElementProviderProps = {
  children: ReactNode
  shellRef: RefObject<HTMLDivElement | null>
}

export const AppShellElementProvider = ({ children, shellRef }: AppShellElementProviderProps) => (
  <AppShellElementContext.Provider value={shellRef}>
    {children}
  </AppShellElementContext.Provider>
)

export const useAppShellElementRef = (): RefObject<HTMLDivElement | null> | null => (
  useContext(AppShellElementContext)
)
